import React from 'react';

function AnswerArticle({ question, answer, isLoading, onReset }) {
  return (
    <div className="max-w-article mx-auto">
      {/* Back Link */}
      <div className="mb-8 text-center">
        <button
          onClick={onReset}
          className="plain-link text-lg"
        >
          ← Ask another absurd question
        </button>
      </div>

      {/* Article Content */}
      <article className="article-content">
        {/* Question Header */}
        <div className="mb-8">
          <h2 className="text-2xl font-mono font-bold mb-4">
            {question}
          </h2>
          <hr />
        </div>

        {/* Answer Content or Loading */}
        {isLoading ? (
          <div className="text-center py-12">
            <div className="inline-block">
              <div className="animate-pulse text-lg font-mono mb-4">
                Thinking...
              </div>
              <div className="flex space-x-1 justify-center">
                <div className="w-2 h-2 bg-black rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-black rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                <div className="w-2 h-2 bg-black rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {answer.split('\n\n').map((paragraph, index) => (
              <p key={index} className="mb-6">
                {paragraph}
              </p>
            ))}
          </div>
        )}

        {/* Footer */}
        {!isLoading && (
          <>
            <hr className="mt-8" />
            <div className="mt-8 text-center space-y-4">
              <button
                onClick={onReset}
                className="plain-link text-lg"
              >
                Ask another question
              </button>
              <div className="text-sm text-muted font-mono">
                Created by Pavel Klimes
              </div>
            </div>
          </>
        )}
      </article>
    </div>
  );
}

export default AnswerArticle; 